export enum ContactCommentType {
    GENERAL = "GENERAL",
    SMALLTALK = "SMALLTALK",
    RISK_PROFILE = "RISK_PROFILE"
  }
  export interface ContentItem {
    id: number;
    content?: string;
    created_at?: string;
    updated_at?: string;
  }
  
  export class ContactComment implements ContentItem {
    id: number;
    user_id: number;
    contact_id: number;
    comment_type: ContactCommentType;
    content: string;
    created_at?: string;
    updated_at?: string;
    reported_period?: string;
    product_type?: number | null;
    handler_code?: string | null;
    policy_number?: string | null;
    constructor(init?: Partial<ContactComment>) {
      Object.assign(this, init);
    }
  
    static defaultEmpty(params: {
      user_id: number;
      contact_id: number;
      comment_type: ContactCommentType;
    }): ContactComment {
      return new ContactComment({
        user_id: params.user_id,
        contact_id: params.contact_id,
        comment_type: params.comment_type,
        content: "",
      });
    }
  }
  